import * as React from 'react';
import {
BookingButton,
BookingButtonMedium,
BookingButtonSmall,
CallToActionButtonDisabled,
CallToActionButtonDisabledMedium,
CallToActionButtonDisabledSmall,
CallToActionButtonMedium,
CallToActionButtonSmall,
BookingButtonLarge,
CallToActionButtonDisabledLarge,
CallToActionButtonLarge,
CallToActionButtonWrapper,
IconWrapper,
TextWrapper
} from './CallToActionButtonStyles'
import { ButtonProps } from '@mui/material/Button';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { actionTaken } from '../../ReduxApp/app/user-sessions/duck/operations';
import { AvailableActions } from '../../ReduxApp/app/user-sessions/duck/actionTypes';
import { useLocation } from 'react-router-dom';

export type Props = {
	icon?: React.ReactNode;
	text: string;
	href?: string;
	onClick?: (e: any) => void;
	fullWidth?: boolean;
	queryParams?: any;
	bookingButton?: boolean;
	userAction?: string;
	tabIndex?: number;
	disabled?: boolean;
	style?: any;
	size?: 'small' | 'medium' | 'large';
};

export const CallToActionButtonLayout = (props: Props) => {
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigateToLink = () => {
		if (props.href) {
			dispatch(actionTaken(AvailableActions.BUTTON_PRESSED, props.userAction ? props.userAction : '', location.pathname));
			navigate(props.href);
		}
	};

	const onClick = !props.onClick
		? () => {}
		: (e: any) => {
				dispatch(actionTaken(AvailableActions.BUTTON_PRESSED, props.userAction ? props.userAction : '', location.pathname));
				if (props.onClick) props.onClick(e);
		  };
	const render = () => {
		const size = props.size ? props.size : 'medium';
		const bookingButton = props.bookingButton || typeof props.bookingButton === 'undefined' ? true : false;
		const href = props.queryParams ? props.href + '?queryParams=' + encodeURIComponent(JSON.stringify(props.queryParams)) : props.href;
		const buttonProps: ButtonProps = {
			// startIcon: props.icon,
			variant: 'contained',
			onClick: props.onClick ? onClick : navigateToLink,
			fullWidth: props.fullWidth ? props.fullWidth : false,
			tabIndex: props.tabIndex,
			disabled: props.disabled ? props.disabled : false,
			style: props.style ? props.style : {},
			size: size,
			className: props.text.toLowerCase().replace(/ /g, '_'),
			href,
		};
		let CTAButton = CallToActionButtonMedium;
		switch (size) {
			case 'small':
				CTAButton = CallToActionButtonSmall;
				if (bookingButton) CTAButton = BookingButtonSmall;
				if (props.disabled) CTAButton = CallToActionButtonDisabledSmall;
				break;
			case 'medium':
				CTAButton = CallToActionButtonMedium;
				if (bookingButton) CTAButton = BookingButtonMedium;
				if (props.disabled) CTAButton = CallToActionButtonDisabledMedium;
				break;
			case 'large':
				CTAButton = CallToActionButtonLarge;
				if (bookingButton) CTAButton = BookingButtonLarge;
				if (props.disabled) CTAButton = CallToActionButtonDisabledLarge;
				break;
		}
		if (bookingButton) CTAButton = BookingButton;
		if (props.disabled) CTAButton = CallToActionButtonDisabled;

		const iconJSX = !props.icon ? null : <IconWrapper>{props.icon}</IconWrapper>;

		const returnValue = (
			<CallToActionButtonWrapper>
				<CTAButton {...buttonProps}>
					{iconJSX}
					<TextWrapper>{props.text}</TextWrapper>
				</CTAButton>
			</CallToActionButtonWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
